












import {defineComponent, ref} from '@vue/composition-api'
import ImageAtom from '@/shared/components/atoms/ImageAtom.vue'
import {useIntersectionObserver} from "@vueuse/core";

export default defineComponent({
  name: "ImageRatioMolecule",
  components: {
    ImageAtom
  },
  props: {
    url: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    ratio: {
      type: String,
      required: true,
      default: "3x4",
      validator: (value: string) => {
        // matches the ratios defined in VU.Web.Assets/Styles/_image.scss
        return ['3x2', '3x4', '4x3'].includes(value);
      },
    },
    fallback: {
      type: String,
      validator: (value: string) => {
        // matches a part of the fallback class defined in VU.Web.Assets/Styles/_image.scss
        return ['vulogo', 'actalogo', 'profile'].includes(value);
      }
    },
  },
  setup: () => {
    const target = ref(null)
    const targetIsVisible = ref(false)

    useIntersectionObserver(target, ([{isIntersecting}]) => {
          targetIsVisible.value = isIntersecting
        }
    )
    
    return {
      target,
      targetIsVisible,
    }
  }
})
